/* import __COLOCATED_TEMPLATE__ from './default.hbs'; */
import Component from '@glimmer/component';

import { LottiePlayer, Spinner } from '@repo/design-system-kit';

import styles from './default.module.css';

export default class FourthlineErrorsDefaultComponent extends Component {
  spinner = Spinner;
  styles = styles;

  lottiePlayer = LottiePlayer;
}
